import { useQuery } from '@tanstack/react-query';

import { statistaDatasetsQuery, type StatistaDataset } from '@/entities/analysis';

import { useIqStatistaChartsEnabled } from '../../../utils/useIqStatistaChartsEnabled';

interface UseStatistaDatasetsResult {
  datasets: StatistaDataset[];
}

/**
 * Statista datasets for the Category & Competition section. The flag gates the
 * request itself, not just the markup, so a report with the feature off makes
 * no call. `hasSection` does the same for a report with no category data to cite from.
 *
 * The backend already scopes to Block B, so the order it returns is the order
 * rendered.
 */
export const useStatistaDatasets = (
  analysisId?: string,
  { hasSection = true } = {},
): UseStatistaDatasetsResult => {
  const enabled = useIqStatistaChartsEnabled() && hasSection;
  const { data } = useQuery(statistaDatasetsQuery(analysisId, { enabled }));

  // Gated on the output as well as the request: a disabled query still reads whatever the
  // cache holds, so a flag flipped off mid-session would otherwise keep serving it.
  return { datasets: enabled ? (data ?? []) : [] };
};
